module.exports = __webpack_public_path__ + "assets/b44.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b44.png
// module id = 632
// module chunks = 0